import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("guango_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const TOOLS = [
  {
    id: "que-dibujo",
    title: "¿Qué dibujo?",
    tagline: "Inspiración para dibujar con diferentes temáticas",
    color: "#FFB000",
    icon: "ImageIcon",
    path: "/que-dibujo",
  },
  {
    id: "pen-battle",
    title: "Pen Battle",
    tagline: "Reto de dibujo rápido, despierta tu mente",
    color: "#06B6D4",
    icon: "Pencil",
    path: "/pen-battle",
  },
  {
    id: "emoji-battle",
    title: "Emoji Battle",
    tagline: "Reto para crear o dibujar una historia",
    color: "#EC4899",
    icon: "Smile",
    path: "/emoji-battle",
  },
  {
    id: "objeto-imposible",
    title: "Objeto Imposible",
    tagline: "Híbridos absurdos generados por IA. Dibújalos.",
    color: "#22C55E",
    icon: "Sparkles",
    path: "/objeto-imposible",
  },
  {
    id: "cliente-imposible",
    title: "Cliente Imposible",
    tagline: "El brief más absurdo que jamás recibirás",
    color: "#EF4444",
    icon: "Briefcase",
    path: "/cliente-imposible",
    isNew: true,
  },
  {
    id: "paleta-maldita",
    title: "Paleta Maldita",
    tagline: "Diseña algo hermoso con los peores colores",
    color: "#A855F7",
    icon: "Palette",
    path: "/paleta-maldita",
    isNew: true,
  },
  {
    id: "tipografia-torturada",
    title: "Tipografía Torturada",
    tagline: "Lettering con el estilo más contradictorio",
    color: "#6366F1",
    icon: "Type",
    path: "/tipografia-torturada",
    isNew: true,
  },
  {
    id: "logo-en-60",
    title: "Logo en 60s",
    tagline: "Sketcha un logo antes de que acabe el tiempo",
    color: "#F97316",
    icon: "Zap",
    path: "/logo-en-60",
    isNew: true,
  },
];

export const TOOL_LABEL = Object.fromEntries(TOOLS.map((t) => [t.id, t.title]));
export const TOOL_COLOR = Object.fromEntries(TOOLS.map((t) => [t.id, t.color]));
export const TOOL_PATH = Object.fromEntries(TOOLS.map((t) => [t.id, t.path]));
